import { render, staticRenderFns } from "./admin-tools-icon.vue?vue&type=template&id=67270853"
import script from "./admin-tools-icon.vue?vue&type=script&lang=js"
export * from "./admin-tools-icon.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports